var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"my-4",attrs:{"align":"center","no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('span',{staticClass:"text-h2",style:({ color: _vm.lightPrimary }),domProps:{"textContent":_vm._s(_vm.title)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }